import React, { useEffect, useRef } from 'react'

import { Header } from 'goustouicomponents/dist/Header'
import { Footer } from 'goustouicomponents/dist/Footer'
import { cookieBanner, browserScripts } from '@gousto-internal/storage-consent-web-package'
import '@gousto-internal/storage-consent-web-package/dist/storageConsentBanner.css'

import { Glassdoor } from './components/Glassdoor'
import { Benefits } from './components/Benefits'
import { HeroMessage } from './components/HeroMessage'
import { Openings } from './components/Openings'
import { OurLocation } from './components/OurLocation'
import { OurTeam } from './components/OurTeam/OurTeam'
import { WhoWeAre } from './components/WhoWeAre'
import { WorkingAtGousto } from './components/WorkingAtGousto'
import { WhyWorkWithUs } from './components/WhyWorkWithUs'

const App = () => {
  const openingsRef = useRef(null)

  useEffect(() => {
    cookieBanner.init()
  }, [])

  const hasConsentForGlassdoor = browserScripts.hasConsent('Glassdoor')

  return (
    <>
      <Header isAuthenticated={false} />
      <HeroMessage openingsRef={openingsRef} />
      <WhoWeAre />
      <WorkingAtGousto />
      <OurTeam />
      <WhyWorkWithUs />
      {hasConsentForGlassdoor && <Glassdoor />}
      <OurLocation />
      <Benefits />
      <div ref={openingsRef}>
        <Openings />
      </div>
      <Footer />
    </>
  )
}

export { App }
